const useFilterBar = () => {
  return {
    submit: document.FILTER_BAR_SUBMIT
  }
}
export default useFilterBar